import { IUser } from "@/shared/model/user.model";

export interface IEdoFriendship {
  user?: IUser;
  friend?: IUser;
  createdAt?: string;
}

export const defaultValue: Readonly<IEdoFriendship> = {};
